'use client'
import React, { useMemo } from 'react'
import classes from './styles.module.scss'
import useTimer from './talons/useTimer'

const Timer: React.FC<{
  endDate?: string
  inGame?: boolean
  title?: string | null
  hideFinishLabel?: boolean
  showTimeLabels?: boolean
  justTime?: boolean
}> = ({
  endDate,
  inGame,
  title,
  hideFinishLabel = false,
  showTimeLabels = true,
  justTime = false,
}) => {
  const { t, time, hasInfoAboutTournament } = useTimer({ endDate })

  const showTimer = useMemo(
    () => (
      <>
        {!hideFinishLabel && (
          <span className={classes.title}>
            {title ? title : t('translation.timeLeft')}
          </span>
        )}

        {justTime ? (
          <div className={classes.justTime}>
            {time.days}:{time.hours}:{time.minutes}:{time.seconds}
          </div>
        ) : (
          <div className={classes.counter}>
            <div>
              {hasInfoAboutTournament ? time.days : 0}
              <span className={classes.grey}>
                {' '}
                {showTimeLabels ? `${t('timer.days')} :` : ' :'}
              </span>
            </div>
            <div>
              {hasInfoAboutTournament ? time.hours : 0}
              <span className={classes.grey}>
                {' '}
                {showTimeLabels ? `${t('timer.hours')} :` : ' :'}
              </span>
            </div>
            <div>
              {hasInfoAboutTournament ? time.minutes : 0}
              <span className={classes.grey}>
                {' '}
                {showTimeLabels ? `${t('timer.minutes')} :` : ' :'}
              </span>
            </div>
            <div>
              {hasInfoAboutTournament ? time.seconds : 0}
              <span className={classes.grey}>
                {' '}
                {showTimeLabels && t('timer.seconds')}
              </span>
            </div>
          </div>
        )}
      </>
    ),
    [
      showTimeLabels,
      justTime,
      hasInfoAboutTournament,
      hideFinishLabel,
      t,
      time.days,
      time.hours,
      time.minutes,
      time.seconds,
      title,
    ],
  )

  return (
    <div
      className={`${classes.container} ${
        inGame ? classes.containerInGame : ''
      }`}
    >
      {time.days < 0 ||
      time.hours < 0 ||
      time.hours < 0 ||
      time.minutes < 0 ||
      time.seconds < 0 ? (
        <div
          className={`${classes.finish} ${inGame ? classes.finishInGame : ''}`}
        >
          {t('tournamentIsFinished')}
        </div>
      ) : (
        showTimer
      )}
    </div>
  )
}

export default Timer
